import Icon from "@ant-design/icons";
import type { CustomIconComponentProps } from "@ant-design/icons/lib/components/Icon";
import { FC } from "react";

export const LocationPlusIconSvg = () => (
  <svg
    width="18"
    height="21"
    viewBox="0 0 18 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.00381 11.23C8.44848 11.23 8.82847 11.0717 9.14381 10.755C9.45914 10.4383 9.61648 10.0573 9.61581 9.612C9.61514 9.16667 9.45648 8.78667 9.13981 8.472C8.82314 8.15733 8.44214 8 7.99681 8C7.55148 8 7.17148 8.15867 6.85681 8.476C6.54214 8.79333 6.38481 9.17433 6.38481 9.619C6.38481 10.0637 6.54314 10.4437 6.85981 10.759C7.17648 11.0743 7.55781 11.2317 8.00381 11.231M7.99981 20.519C5.64981 18.441 3.87981 16.503 2.68981 14.705C1.49914 12.907 0.903809 11.2707 0.903809 9.796C0.903809 7.68067 1.59248 5.936 2.96981 4.562C4.34781 3.18733 6.02448 2.5 7.99981 2.5C8.21781 2.5 8.42614 2.508 8.62481 2.524C8.82348 2.54 9.02547 2.57067 9.23081 2.616V6.269H12.2308V9.269H15.0788C15.0861 9.34967 15.0908 9.43567 15.0928 9.527C15.0948 9.61833 15.0958 9.70833 15.0958 9.797C15.0958 11.2703 14.5008 12.9063 13.3108 14.705C12.1201 16.503 10.3498 18.441 7.99981 20.519ZM13.9998 7.5V4.5H10.9998V3.5H13.9998V0.5H14.9998V3.5H17.9998V4.5H14.9998V7.5H13.9998Z"
      fill="currentColor"
    />
  </svg>
);

export const LocationPlusIcon: FC<Partial<CustomIconComponentProps>> = (
  props
) => <Icon component={LocationPlusIconSvg} {...props} />;

export default LocationPlusIcon;

LocationPlusIcon.displayName = "LocationPlusIcon";
